// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-empanada/issue-navigator-placement';

import { MessageFrontend as createMessageFrontendJiraNinListMergeModalOnboardingV2 } from '@post-office/browser--jira-empanada/jira-nin-list-merge-modal-onboarding-v2/placements/in-app-v2/issue-navigator-placement';
import { MessageFrontend as createMessageFrontendJiraNinListMergeSpotlightOnboardingV2 } from '@post-office/browser--jira-empanada/jira-nin-list-merge-spotlight-onboarding-v2/placements/in-app-v2/issue-navigator-placement';
import { MessageFrontend as createMessageFrontendJiraNinPaidListMergeModalOnboarding } from '@post-office/browser--jira-keystone/jira-nin-paid-list-merge-modal-onboarding/placements/in-app-v2/issue-navigator-placement';
import { MessageFrontend as createMessageFrontendJiraNinGroupingWithHierarchySpotlight } from '@post-office/browser--jira-keystone/jira-nin-grouping-with-hierarchy-spotlight/placements/in-app-v2/issue-navigator-placement';
import { MessageFrontend as createMessageFrontendJiraNinIssuePreviewPanel } from '@post-office/browser--jira-empanada/jira-nin-issue-preview-panel/placements/in-app-v2/issue-navigator-placement';
import { MessageFrontend as createMessageFrontendJiraNinIssuePreviewPanelResize } from '@post-office/browser--jira-empanada/jira-nin-issue-preview-panel-resize/placements/in-app-v2/issue-navigator-placement';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementRenderProps } from '@post-office/browser--jira-empanada/issue-navigator-placement';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendJiraNinListMergeModalOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-modal-onboarding-v2',
	}),
	createMessageFrontendJiraNinListMergeSpotlightOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-spotlight-onboarding-v2',
	}),
	createMessageFrontendJiraNinPaidListMergeModalOnboarding({
		messageTemplateId: 'jira-nin-paid-list-merge-modal-onboarding',
	}),
	createMessageFrontendJiraNinGroupingWithHierarchySpotlight({
		messageTemplateId: 'jira-nin-grouping-with-hierarchy-spotlight',
	}),
	createMessageFrontendJiraNinIssuePreviewPanel({
		messageTemplateId: 'jira-nin-issue-preview-panel',
	}),
	createMessageFrontendJiraNinIssuePreviewPanelResize({
		messageTemplateId: 'jira-nin-issue-preview-panel-resize',
	}),
];

export const RawPlacement: PlacementRendererStage<PlacementRenderProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementRenderProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementRenderProps> = RawPlacement;
